module.exports = __webpack_public_path__ + "img/wexperts-react-fb-shot.0a106a76.jpg";